// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GgKm","col":"styles_col__1UCA5"};